module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxNSI+PHRpdGxlPkNhbmNlbDwvdGl0bGU+PHBhdGggZD0iTTcuNTMsMEE3LjQ3LDcuNDcsMCwxLDAsMTUsNy40Nyw3LjQ3LDcuNDcsMCwwLDAsNy41MywwWk05LjI3LDExLjU3LDcuNjcsOWwtMS42LDIuNjFIMy4yNmwyLjgtNC4yM0wzLjUyLDMuNDVINi4yOGwxLjQ0LDIuNSwxLjQtMi41aDIuNzRMOS4zMyw3LjM4bDIuNzcsNC4xOVoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/img/cancel.svg
// module id = 823
// module chunks = 0